import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CCodeRotation, CCorrectLevel} from "../types";

export class CQRCode extends BasicCPCLArg<CQRCode> {
  private x: number;
  private y: number;
  private content: string;
  private codeRotation: CCodeRotation;
  private width: number
  private level: CCorrectLevel;
  private charset: string;
  constructor(options: {
    /**
     * 一维码起始横坐标
     */
    x?: number
    /**
     * 一维码起始纵坐标
     */
    y?: number
    /**
     * 条码内容
     */
    content?: string
    /**
     * 旋转
     */
    codeRotation?: CCodeRotation
    /**
     * 二维码小黑点宽度(2-20)
     */
    width?: number
    /**
     * QrCode纠错等级
     */
    level?: CCorrectLevel
    /**
     * 编码
     */
    charset?: string
  }) {
    super();
    this.x = options.x ?? 0;
    this.y = options.y ?? 0;
    this.content = options.content ?? '';
    this.codeRotation = options.codeRotation ?? CCodeRotation.ROTATION_0;
    this.width = options.width ?? 0;
    this.level = options.level ?? CCorrectLevel.H;
    this.charset = options.charset ?? 'gbk';
  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header(),this.charset)
      .appendText("3" + "\n" + this.codeRotation)
      .appendText("QR")
      .appendNumber(this.x)
      .appendNumber(this.y)
      .appendText("M")
      .appendText("2")
      .appendText("U")
      .appendText(this.width + "\n" + this.level + "A," + this.content + "\n" + "ENDQR")
      .clause();
  }

  header(): string {
    return 'SETQRVER';
  }
}



